/* Centilmen - Beden Bulucu
   Boy / kilo (ve istege bagli olculer) ile tahmini beden onerir.
   - [data-beden-form] icine form cizer (ana sayfa bolumu)
   - [data-beden-bul] tiklaninca pencere acar
   - Urun sayfasinda beden seceneklerinin altina "Bedenimi Bul" ekler ve onerilen bedeni isaretler
*/
(function () {
  if (window.__bedenBul) return;
  window.__bedenBul = true;

  var ANAHTAR = 'centilmenBeden';
  var WHATSAPP = 'https://wa.me/905333847358';

  // Standart beden tablolari (ust sinir, cm)
  var KADIN = [
    { h: 'XS',  n: '34', g: 83,  b: 65, k: 91 },
    { h: 'S',   n: '36', g: 87,  b: 69, k: 95 },
    { h: 'M',   n: '38', g: 91,  b: 73, k: 99 },
    { h: 'L',   n: '40', g: 95,  b: 77, k: 103 },
    { h: 'XL',  n: '42', g: 99,  b: 81, k: 107 },
    { h: '2XL', n: '44', g: 103, b: 85, k: 111 },
    { h: '3XL', n: '46', g: 107, b: 89, k: 115 },
    { h: '4XL', n: '48', g: 111, b: 93, k: 119 },
    { h: '5XL', n: '50', g: 115, b: 97, k: 123 }
  ];
  var ERKEK = [
    { h: 'S',   n: '46', g: 92,  b: 80 },
    { h: 'M',   n: '48', g: 98,  b: 86 },
    { h: 'L',   n: '50', g: 104, b: 92 },
    { h: 'XL',  n: '52', g: 110, b: 98 },
    { h: '2XL', n: '54', g: 116, b: 104 },
    { h: '3XL', n: '56', g: 122, b: 110 },
    { h: '4XL', n: '58', g: 128, b: 116 }
  ];

  function oku() { try { return JSON.parse(localStorage.getItem(ANAHTAR) || 'null'); } catch (e) { return null; } }
  function yaz(v) { try { localStorage.setItem(ANAHTAR, JSON.stringify(v)); } catch (e) {} }

  function sira(tablo, alan, deger) {
    if (!deger) return -1;
    for (var i = 0; i < tablo.length; i++) if (deger <= tablo[i][alan]) return i;
    return tablo.length - 1;
  }

  function hesapla(v) {
    var tablo = v.cins === 'erkek' ? ERKEK : KADIN;
    var boy = v.boy, kilo = v.kilo;
    var gogus = v.gogus, bel = v.bel, basen = v.basen;
    // Olcu girilmediyse boy/kilodan tahmin et
    if (v.cins === 'erkek') {
      if (!gogus) gogus = 62 + 0.45 * kilo - 0.08 * (boy - 178);
      if (!bel) bel = 30 + 0.7 * kilo - 0.2 * (boy - 178);
    } else {
      if (!gogus) gogus = 52 + 0.6 * kilo - 0.12 * (boy - 165);
      if (!basen) basen = 58 + 0.64 * kilo - 0.1 * (boy - 165);
    }
    var idx = Math.max(sira(tablo, 'g', gogus), sira(tablo, 'b', v.bel ? bel : (v.cins === 'erkek' ? bel : 0)), tablo[0].k ? sira(tablo, 'k', basen) : -1, 0);
    if (v.tercih === 'rahat') idx = Math.min(idx + 1, tablo.length - 1);
    var s = tablo[idx];
    var sonuc = { cins: v.cins, harf: s.h, numara: s.n, tahmini: !(v.gogus || v.bel || v.basen) };
    if (v.cins === 'erkek') sonuc.jean = Math.round(bel / 2.54);
    return sonuc;
  }

  function sonucMetni(r) {
    if (r.cins === 'erkek') {
      return '<div class="bb-sonuc-beden">' + r.harf + '</div>' +
        '<div class="bb-sonuc-detay">Üst giyim: <b>' + r.harf + '</b> · Takım elbise / ceket: <b>' + r.numara + '</b>' +
        (r.jean ? ' · Jean (bel): <b>' + r.jean + '</b>' : '') + '</div>';
    }
    return '<div class="bb-sonuc-beden">' + r.harf + ' <span>(' + r.numara + ')</span></div>' +
      '<div class="bb-sonuc-detay">Harf beden: <b>' + r.harf + '</b> · Numara beden: <b>' + r.numara + '</b></div>';
  }

  function formHTML(kayit) {
    var c = (kayit && kayit.girdi) || {};
    var cins = c.cins || 'kadin';
    return '' +
      '<form class="bb-form" novalidate>' +
        '<div class="bb-cins" role="radiogroup">' +
          '<button type="button" class="bb-cins-btn' + (cins === 'kadin' ? ' is-aktif' : '') + '" data-cins="kadin">KADIN</button>' +
          '<button type="button" class="bb-cins-btn' + (cins === 'erkek' ? ' is-aktif' : '') + '" data-cins="erkek">ERKEK</button>' +
        '</div>' +
        '<div class="bb-satir">' +
          '<label class="bb-alan"><span>Boy (cm)</span><input type="number" inputmode="numeric" name="boy" min="140" max="210" placeholder="Örn. 168" value="' + (c.boy || '') + '" required></label>' +
          '<label class="bb-alan"><span>Kilo (kg)</span><input type="number" inputmode="numeric" name="kilo" min="35" max="180" placeholder="Örn. 62" value="' + (c.kilo || '') + '" required></label>' +
        '</div>' +
        '<div class="bb-tercih-bas">Nasıl giymeyi seversin?</div>' +
        '<div class="bb-tercih">' +
          '<label><input type="radio" name="tercih" value="tam"' + (c.tercih === 'tam' ? ' checked' : '') + '><span>Vücuda oturan</span></label>' +
          '<label><input type="radio" name="tercih" value="normal"' + (!c.tercih || c.tercih === 'normal' ? ' checked' : '') + '><span>Normal</span></label>' +
          '<label><input type="radio" name="tercih" value="rahat"' + (c.tercih === 'rahat' ? ' checked' : '') + '><span>Rahat / bol</span></label>' +
        '</div>' +
        '<details class="bb-olcu"' + (c.gogus || c.bel || c.basen ? ' open' : '') + '><summary>Daha kesin sonuç için ölçülerimi de girmek istiyorum</summary>' +
          '<div class="bb-satir bb-satir--3">' +
            '<label class="bb-alan"><span>Göğüs (cm)</span><input type="number" inputmode="numeric" name="gogus" min="60" max="160" value="' + (c.gogus || '') + '"></label>' +
            '<label class="bb-alan"><span>Bel (cm)</span><input type="number" inputmode="numeric" name="bel" min="50" max="160" value="' + (c.bel || '') + '"></label>' +
            '<label class="bb-alan bb-basen"><span>Basen (cm)</span><input type="number" inputmode="numeric" name="basen" min="70" max="170" value="' + (c.basen || '') + '"></label>' +
          '</div>' +
        '</details>' +
        '<button type="submit" class="bb-hesapla">BEDENİMİ BUL</button>' +
        '<div class="bb-hata" hidden>Lütfen boy ve kilonu gir.</div>' +
        '<div class="bb-sonuc" hidden></div>' +
      '</form>';
  }

  function baglaForm(kok, kapatinca) {
    var form = kok.querySelector('.bb-form');
    var cins = form.querySelector('.bb-cins-btn.is-aktif').getAttribute('data-cins');
    function basenGoster() { var b = form.querySelector('.bb-basen'); if (b) b.style.display = cins === 'erkek' ? 'none' : ''; }
    basenGoster();
    form.querySelectorAll('.bb-cins-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        cins = b.getAttribute('data-cins');
        form.querySelectorAll('.bb-cins-btn').forEach(function (x) { x.classList.toggle('is-aktif', x === b); });
        basenGoster();
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sayi = function (ad) { var v = parseFloat((form.elements[ad] || {}).value); return isFinite(v) && v > 0 ? v : 0; };
      var girdi = { cins: cins, boy: sayi('boy'), kilo: sayi('kilo'), gogus: sayi('gogus'), bel: sayi('bel'), basen: cins === 'erkek' ? 0 : sayi('basen') };
      var t = form.querySelector('input[name="tercih"]:checked');
      girdi.tercih = t ? t.value : 'normal';
      var hata = form.querySelector('.bb-hata');
      if (!girdi.boy || !girdi.kilo || girdi.boy < 130 || girdi.boy > 220 || girdi.kilo < 30 || girdi.kilo > 200) { hata.hidden = false; return; }
      hata.hidden = true;
      var r = hesapla(girdi);
      yaz({ girdi: girdi, sonuc: r, zaman: Date.now() });
      var alan = form.querySelector('.bb-sonuc');
      alan.innerHTML =
        '<div class="bb-sonuc-ust">Önerilen bedenin</div>' + sonucMetni(r) +
        '<p class="bb-not">' + (r.tahmini ? 'Boy ve kilona göre tahmini bedendir. ' : '') +
        'Markaların kalıpları farklılık gösterebilir; emin olamazsan <a href="' + WHATSAPP + '" target="_blank" rel="noopener">WhatsApp’tan sor</a>, birlikte seçelim.</p>' +
        '<p class="bb-not bb-not--kucuk">Bedenini hatırladık: ürün sayfalarında sana uygun beden işaretli görünecek.</p>';
      alan.hidden = false;
      urunSayfasiniIsaretle();
      if (kapatinca) kapatinca(r);
    });
  }

  // ---------- Pencere ----------
  var pencere;
  function pencereAc() {
    if (!pencere) {
      pencere = document.createElement('div');
      pencere.className = 'bb-pencere';
      pencere.innerHTML = '<div class="bb-kart" role="dialog" aria-modal="true" aria-label="Beden Bulucu">' +
        '<button type="button" class="bb-kapat" aria-label="Kapat">✕</button>' +
        '<div class="bb-kart-bas"><span class="bb-ust">BEDEN BULUCU</span><h3>Bedenini 10 saniyede bul</h3></div>' +
        '<div class="bb-kart-ic"></div></div>';
      document.body.appendChild(pencere);
      pencere.addEventListener('click', function (e) { if (e.target === pencere || e.target.closest('.bb-kapat')) pencereKapat(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') pencereKapat(); });
    }
    var ic = pencere.querySelector('.bb-kart-ic');
    ic.innerHTML = formHTML(oku());
    baglaForm(ic);
    pencere.classList.add('is-acik');
    document.documentElement.style.overflow = 'hidden';
  }
  function pencereKapat() {
    if (!pencere) return;
    pencere.classList.remove('is-acik');
    document.documentElement.style.overflow = '';
  }

  // ---------- Urun sayfasi ----------
  function bedenKutusu() {
    var kutular = document.querySelectorAll('.lfn-dropdown-box');
    for (var i = 0; i < kutular.length; i++) {
      var etiket = kutular[i].querySelector('.lfn-box-label');
      var t = etiket ? etiket.textContent.toLocaleLowerCase('tr') : '';
      if (t.indexOf('beden') > -1 || t.indexOf('size') > -1 || t.indexOf('numara') > -1) return kutular[i];
    }
    return null;
  }
  function urunSayfasiniIsaretle() {
    var kutu = bedenKutusu();
    if (!kutu) return;
    var kayit = oku();
    var bilgi = kutu.parentNode.querySelector('.bb-urun-satir');
    if (!bilgi) {
      bilgi = document.createElement('div');
      bilgi.className = 'bb-urun-satir';
      kutu.parentNode.insertBefore(bilgi, kutu.nextSibling);
    }
    var r = kayit && kayit.sonuc;
    bilgi.innerHTML =
      '<button type="button" class="bb-urun-btn" data-beden-bul>' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>' +
        (r ? 'Bedenini yeniden hesapla' : 'Bedenimi Bul') + '</button>' +
      (r ? '<span class="bb-urun-oneri">Önerilen bedenin: <b>' + r.harf + (r.numara ? ' / ' + r.numara : '') + '</b></span>' : '');
    kutu.querySelectorAll('.lfn-menu-item').forEach(function (m) { m.classList.remove('bb-onerilen'); });
    if (!r) return;
    var adaylar = [r.harf, r.numara, String(r.jean || '')].filter(Boolean).map(function (x) { return x.toLocaleUpperCase('tr'); });
    kutu.querySelectorAll('.lfn-menu-item').forEach(function (m) {
      var ad = (m.querySelector('.lfn-item-name') || m).textContent.trim().toLocaleUpperCase('tr');
      if (adaylar.indexOf(ad) > -1) m.classList.add('bb-onerilen');
    });
  }

  // ---------- Stil ----------
  var css = '' +
    '.bb-form{font-family:inherit;color:#111}' +
    '.bb-cins{display:inline-flex;gap:6px;padding:4px;border:1px solid #e8e2da;border-radius:30px;background:#fff;margin-bottom:18px}' +
    '.bb-cins-btn{border:0;background:transparent;padding:9px 24px;border-radius:30px;font:inherit;font-size:11.5px;font-weight:600;letter-spacing:.16em;color:#777;cursor:pointer}' +
    '.bb-cins-btn.is-aktif{background:#111;color:#fff}' +
    '.bb-satir{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px}' +
    '.bb-satir--3{grid-template-columns:repeat(3,1fr);margin:12px 0 4px}' +
    '.bb-alan{display:flex;flex-direction:column;gap:6px;font-size:11px;font-weight:600;letter-spacing:.06em;color:#6b6b6b;text-transform:uppercase}' +
    '.bb-alan input{width:100%;height:46px;padding:0 14px;border:1px solid #e3ddd5;border-radius:8px;background:#fff;font:inherit;font-size:16px;color:#111;box-sizing:border-box}' +
    '.bb-alan input:focus{outline:none;border-color:#6d5b52;box-shadow:0 0 0 3px rgba(109,91,82,.12)}' +
    '.bb-tercih-bas{font-size:11px;font-weight:600;letter-spacing:.06em;color:#6b6b6b;text-transform:uppercase;margin-bottom:8px}' +
    '.bb-tercih{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:14px}' +
    '.bb-tercih label{cursor:pointer}.bb-tercih input{position:absolute;opacity:0;pointer-events:none}' +
    '.bb-tercih span{display:inline-block;padding:9px 14px;border:1px solid #e3ddd5;border-radius:20px;font-size:12.5px;background:#fff}' +
    '.bb-tercih input:checked+span{border-color:#111;background:#111;color:#fff}' +
    '.bb-olcu{margin-bottom:16px}.bb-olcu summary{cursor:pointer;font-size:12.5px;color:#6d5b52;text-decoration:underline;text-underline-offset:3px}' +
    '.bb-hesapla{width:100%;height:50px;border:0;border-radius:30px;background:#111;color:#fff;font:inherit;font-size:12px;font-weight:600;letter-spacing:.2em;cursor:pointer}' +
    '.bb-hesapla:hover{background:#333}' +
    '.bb-hata{margin-top:10px;font-size:12.5px;color:#c62828}' +
    '.bb-sonuc{margin-top:18px;padding:18px;border-radius:12px;background:#f4f8f4;border:1px solid #dbe8db;text-align:center;animation:bbGel .4s ease}' +
    '@keyframes bbGel{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}' +
    '.bb-sonuc-ust{font-size:10.5px;font-weight:600;letter-spacing:.24em;color:#2e7d32;text-transform:uppercase}' +
    '.bb-sonuc-beden{font-size:40px;font-weight:600;line-height:1.1;margin:6px 0 4px;color:#111}.bb-sonuc-beden span{font-size:22px;font-weight:400;color:#555}' +
    '.bb-sonuc-detay{font-size:13px;color:#444}' +
    '.bb-not{margin:12px 0 0;font-size:12px;line-height:1.5;color:#6b6b6b}.bb-not a{color:#111}.bb-not--kucuk{margin-top:6px;font-size:11.5px}' +
    '.bb-pencere{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.5)}' +
    '.bb-pencere.is-acik{display:flex}' +
    '.bb-kart{position:relative;width:100%;max-width:440px;max-height:calc(100vh - 32px);overflow:auto;background:#faf8f5;border-radius:14px;padding:28px 24px 24px;box-shadow:0 20px 60px rgba(0,0,0,.25);font-family:Montserrat,-apple-system,BlinkMacSystemFont,sans-serif}' +
    '.bb-kapat{position:absolute;top:12px;right:14px;border:0;background:none;font-size:18px;color:#6d5b52;cursor:pointer}' +
    '.bb-kart-bas{text-align:center;margin-bottom:18px}.bb-kart-bas h3{margin:6px 0 0;font-size:22px;font-weight:400;letter-spacing:.03em}' +
    '.bb-ust{font-size:10px;font-weight:600;letter-spacing:.3em;color:#8a7d74}' +
    '.bb-kart .bb-cins{display:flex;width:max-content;margin:0 auto 18px}' +
    '.bb-urun-satir{display:flex;flex-wrap:wrap;align-items:center;gap:8px 14px;margin:-6px 0 14px}' +
    '.bb-urun-btn{display:inline-flex;align-items:center;gap:6px;border:0;background:none;padding:0;font:inherit;font-size:12.5px;color:#111;text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
    '.bb-urun-btn svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round}' +
    '.bb-urun-oneri{font-size:12.5px;color:#2e7d32}' +
    '.lfn-menu-item.bb-onerilen{position:relative;box-shadow:0 0 0 2px #2e7d32 inset}' +
    '.lfn-menu-item.bb-onerilen::after{content:"ÖNERİLEN";position:absolute;top:-8px;left:50%;transform:translateX(-50%);background:#2e7d32;color:#fff;font-size:8px;font-weight:700;letter-spacing:.06em;padding:2px 5px;border-radius:3px;white-space:nowrap;line-height:1.2}' +
    '@media(max-width:480px){.bb-satir--3{grid-template-columns:1fr 1fr}.bb-sonuc-beden{font-size:34px}}';

  function kur() {
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);

    document.querySelectorAll('[data-beden-form]').forEach(function (k) {
      k.innerHTML = formHTML(oku());
      baglaForm(k);
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-beden-bul]');
      if (t) { e.preventDefault(); pencereAc(); }
    });
    urunSayfasiniIsaretle();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur); else kur();
})();
